import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import NebulaModuleBase from './module-base';
export var UpHttp = function (_NebulaModuleBase) {
    _inherits(UpHttp, _NebulaModuleBase);

    function UpHttp() {
        _classCallCheck(this, UpHttp);

        return _possibleConstructorReturn(this, (UpHttp.__proto__ || Object.getPrototypeOf(UpHttp)).apply(this, arguments));
    }

    _createClass(UpHttp, [{
        key: 'get',
        value: function get(options) {
            var param = {
                url: encodeURI(options.url),
                body: options.data,
                headers: options.headers,
                transform: options.transform
            };
            return this.generatePromiseByFunctionWithParams('getForHTTP', param);
        }
    }, {
        key: 'getCache',
        value: function getCache(options) {
            var _this2 = this;

            var encodeUrl = encodeURI(options.url);
            var event = 'getCacheForHTTP' + encodeUrl;
            var param = {
                eventName: event,
                url: encodeUrl,
                body: options.data,
                headers: options.headers,
                transform: options.transform,
                useCache: options.useCache
            };
            var callback = function callback(result) {
                options.getResponseCallback(result);
                _this2.generatePromiseByDetachListenerWithParams(event, callback);
            };
            this.generatePromiseByAttachListenerWithParams(event, callback);
            return this.generatePromiseByFunctionWithParams('getCacheForHTTP', param);
        }
    }, {
        key: 'post',
        value: function post(options) {
            var param = {
                url: encodeURI(options.url),
                body: options.data,
                headers: options.headers,
                transform: options.transform
            };
            return this.generatePromiseByFunctionWithParams('postForHTTP', param);
        }
    }, {
        key: 'put',
        value: function put(options) {
            var param = {
                url: encodeURI(options.url),
                body: options.data,
                headers: options.headers,
                transform: options.transform
            };
            return this.generatePromiseByFunctionWithParams('putForHTTP', param);
        }
    }, {
        key: 'delete',
        value: function _delete(options) {
            var param = {
                url: encodeURI(options.url),
                body: options.data,
                headers: options.headers,
                transform: options.transform
            };
            return this.generatePromiseByFunctionWithParams('deleteForHTTP', param);
        }
    }, {
        key: 'uploadFile',
        value: function uploadFile(options) {
            var encodeUrl = encodeURI(options.url);
            var param = {
                url: encodeUrl,
                data: options.data,
                headers: options.headers,
                transform: options.transform,
                filePath: options.filePath,
                method: 'post',
                name: options.name
            };
            return this.generatePromiseByFunctionWithParams('uploadFileForHTTP', param);
        }
    }, {
        key: 'uploadFileWithProgress',
        value: function uploadFileWithProgress(options) {
            var _this3 = this;

            var event = 'uploadFileWithProgressForHTTP' + options.uploadId;
            var param = {
                eventName: event,
                url: encodeURI(options.url),
                method: 'post',
                returnAll: true,
                data: options.data,
                headers: options.headers,
                filePath: options.filePath,
                name: options.name,
                uploadId: options.uploadId,
                transform: options.transform
            };
            var callback = function callback(result) {
                options.progress(result);
            };
            this.generatePromiseByAttachListenerWithParams(event, callback);
            return this.generatePromiseByFunctionWithParams('uploadFileWithProgressForHTTP', param)['finally'](function () {
                _this3.generatePromiseByDetachListenerWithParams(event, callback);
            });
        }
    }, {
        key: 'domainTransformToIP',
        value: function domainTransformToIP(params) {
            return this.generatePromiseByFunctionWithParams('domainTransformToIPForHTTP', params);
        }
    }]);

    return UpHttp;
}(NebulaModuleBase);